import { InjectionToken } from '@angular/core';

export interface MenuItem {
    id: string;
    name: string;
    icon: string;
    link: string;
    fragment: string;
    unread: boolean;
}

export const MENU_ITEMS = new InjectionToken<MenuItem[]>('Menu items configuration');
